import { ProvinceWithCities } from './types.ts'
import { REGIONS, LANGUAGES } from '@boltenergy-be/shared'

export const PROVINCES = [
  'Brussels',
  'West-Flanders',
  'East-Flanders',
  'Antwerp',
  'Limburg',
  'Flemish Brabant',
  'Walloon Brabant',
  'Hainaut',
  'Namur',
  'Liege',
  'Luxembourg'
] as const
export type Province = (typeof PROVINCES)[number]

export const AMBITION_CHART_CITIES = 4
export const AMBITION_MAX_BEATEN_CITIES = 3
export const AMBITION_GOAL_MILESTONES = [25_000, 50_000, 75_000, 100_000, 200_000]
export const AMBITION_GOAL_STEP_ABOVE_MILESTONES = 100_000
export const PROVINCES_WITH_CITIES: ProvinceWithCities[] = [
  {
    province: 'Brussels',
    region: REGIONS.brussels,
    cities: [
      { name: { [LANGUAGES.NL]: 'Brussel', [LANGUAGES.FR]: 'Bruxelles' }, population: 198_005, emission: 298_156_194 },
      { name: { [LANGUAGES.NL]: 'Schaarbeek', [LANGUAGES.FR]: 'Schaerbeek' }, population: 127_409, emission: 191_852_643 },
      { name: { [LANGUAGES.NL]: 'Elsene', [LANGUAGES.FR]: 'Ixelles' }, population: 89_154, emission: 134_248_213 },
      { name: { [LANGUAGES.NL]: 'Vorst', [LANGUAGES.FR]: 'Forest' }, population: 58_856, emission: 88_625_444 },
      { name: { [LANGUAGES.NL]: 'Sint-Pieters-Woluwe', [LANGUAGES.FR]: 'Woluwe-Saint-Pierre' }, population: 42_500, emission: 63_996_557 },
      { name: { [LANGUAGES.NL]: 'Oudergem', [LANGUAGES.FR]: 'Auderghem' }, population: 35_661, emission: 53_698_382 }
    ]
  },
  {
    province: 'West-Flanders',
    region: REGIONS.flanders,
    cities: [
      { name: { [LANGUAGES.NL]: 'Brugge', [LANGUAGES.FR]: 'Bruges' }, population: 120_393, emission: 181_287_941 },
      { name: { [LANGUAGES.NL]: 'Kortrijk', [LANGUAGES.FR]: 'Courtrai' }, population: 81_484, emission: 122_698_716 },
      { name: { [LANGUAGES.NL]: 'Roeselare', [LANGUAGES.FR]: 'Roulers' }, population: 67_622, emission: 101_825_298 },
      { name: { [LANGUAGES.NL]: 'Waregem', [LANGUAGES.FR]: 'Waregem' }, population: 40_733, emission: 61_335_806 },
      { name: { [LANGUAGES.NL]: 'Ieper', [LANGUAGES.FR]: 'Ypres' }, population: 35_610, emission: 53_621_586 },
      { name: { [LANGUAGES.NL]: 'Harelbeke', [LANGUAGES.FR]: 'Harelbeke' }, population: 30_585, emission: 46_054_934 }
    ]
  },
  {
    province: 'East-Flanders',
    region: REGIONS.flanders,
    cities: [
      { name: { [LANGUAGES.NL]: 'Gent', [LANGUAGES.FR]: 'Gand' }, population: 273_665, emission: 412_085_124 },
      { name: { [LANGUAGES.NL]: 'Aalst', [LANGUAGES.FR]: 'Alost' }, population: 93_078, emission: 140_156_977 },
      { name: { [LANGUAGES.NL]: 'Sint Niklaas', [LANGUAGES.FR]: 'Saint-Nicolas' }, population: 83_328, emission: 125_475_414 },
      { name: { [LANGUAGES.NL]: 'Beveren', [LANGUAGES.FR]: 'Beveren' }, population: 49_062, emission: 73_877_625 },
      { name: { [LANGUAGES.NL]: 'Lokeren', [LANGUAGES.FR]: 'Lokeren' }, population: 42_145, emission: 63_461_997 },
      { name: { [LANGUAGES.NL]: 'Geraardsbergen', [LANGUAGES.FR]: 'Grammont' }, population: 33_970, emission: 51_152_071 }
    ]
  },
  {
    province: 'Antwerp',
    region: REGIONS.flanders,
    cities: [
      { name: { [LANGUAGES.NL]: 'Antwerpen', [LANGUAGES.FR]: 'Anvers' }, population: 564_561, emission: 850_116_710 },
      { name: { [LANGUAGES.NL]: 'Mechelen', [LANGUAGES.FR]: 'Malines' }, population: 90_282, emission: 135_946_757 },
      { name: { [LANGUAGES.NL]: 'Turnhout', [LANGUAGES.FR]: 'Turnhout' }, population: 48_441, emission: 72_942_523 },
      { name: { [LANGUAGES.NL]: 'Heist-op-den-berg', [LANGUAGES.FR]: 'Heist-op-den-Berg' }, population: 44_983, emission: 67_735_462 },
      { name: { [LANGUAGES.NL]: 'Geel', [LANGUAGES.FR]: 'Geel' }, population: 42_604, emission: 64_153_160 },
      { name: { [LANGUAGES.NL]: 'Brasschaat', [LANGUAGES.FR]: 'Brasschaat' }, population: 38_522, emission: 58_006_479 }
    ]
  },
  {
    province: 'Limburg',
    region: REGIONS.flanders,
    cities: [
      { name: { [LANGUAGES.NL]: 'Hasselt', [LANGUAGES.FR]: 'Hasselt' }, population: 90_875, emission: 136_839_697 },
      { name: { [LANGUAGES.NL]: 'Genk', [LANGUAGES.FR]: 'Genk' }, population: 68_068, emission: 102_496_886 },
      { name: { [LANGUAGES.NL]: 'Beringen', [LANGUAGES.FR]: 'Beringen' }, population: 49_026, emission: 73_823_416 },
      { name: { [LANGUAGES.NL]: 'Sint-Truiden', [LANGUAGES.FR]: 'Saint-Trond' }, population: 41_964, emission: 63_189_447 },
      { name: { [LANGUAGES.NL]: 'Heusden-Zolder', [LANGUAGES.FR]: 'Heusden-Zolder' }, population: 35_029, emission: 52_746_715 },
      { name: { [LANGUAGES.NL]: 'Houthalen-Helchteren', [LANGUAGES.FR]: 'Houthalen-Helchteren' }, population: 30_866, emission: 46_478_064 }
    ]
  },
  {
    province: 'Flemish Brabant',
    region: REGIONS.flanders,
    cities: [
      { name: { [LANGUAGES.NL]: 'Leuven', [LANGUAGES.FR]: 'Louvain' }, population: 105_233, emission: 158_459_992 },
      { name: { [LANGUAGES.NL]: 'Vilvoorde', [LANGUAGES.FR]: 'Vilvorde' }, population: 48_401, emission: 72_882_291 },
      { name: { [LANGUAGES.NL]: 'Dilbeek', [LANGUAGES.FR]: 'Dilbeek' }, population: 45_103, emission: 67_916_158 },
      { name: { [LANGUAGES.NL]: 'Sint-Pieters-Leeuw', [LANGUAGES.FR]: 'Leeuw-Saint-Pierre' }, population: 37_051, emission: 55_791_445 },
      { name: { [LANGUAGES.NL]: 'Asse', [LANGUAGES.FR]: 'Asse' }, population: 35_996, emission: 54_202_825 },
      { name: { [LANGUAGES.NL]: 'Diest', [LANGUAGES.FR]: 'Diest' }, population: 25_180, emission: 37_916_078 }
    ]
  },
  {
    province: 'Walloon Brabant',
    region: REGIONS.wallonia,
    cities: [
      { name: { [LANGUAGES.NL]: 'Eigenbrakel', [LANGUAGES.FR]: "Braine-l'Alleud" }, population: 40_807, emission: 61_447_235 },
      { name: { [LANGUAGES.NL]: 'Waver', [LANGUAGES.FR]: 'Wavre' }, population: 35_727, emission: 53_797_764 },
      { name: { [LANGUAGES.NL]: 'Waterloo', [LANGUAGES.FR]: 'Waterloo' }, population: 30_374, emission: 45_737_210 },
      { name: { [LANGUAGES.NL]: 'Nijvel', [LANGUAGES.FR]: 'Nivelles' }, population: 29_808, emission: 44_884_926 },
      { name: { [LANGUAGES.NL]: 'Tubeke', [LANGUAGES.FR]: 'Tubize' }, population: 29_044, emission: 43_734_494 },
      { name: { [LANGUAGES.NL]: 'Rixensart', [LANGUAGES.FR]: 'Rixensart' }, population: 22_972, emission: 34_591_268 }
    ]
  },
  {
    province: 'Hainaut',
    region: REGIONS.wallonia,
    cities: [
      { name: { [LANGUAGES.NL]: 'Charleroi', [LANGUAGES.FR]: 'Charleroi' }, population: 206_585, emission: 311_075_970 },
      { name: { [LANGUAGES.NL]: 'Bergen', [LANGUAGES.FR]: 'Mons' }, population: 97_337, emission: 146_570_185 },
      { name: { [LANGUAGES.NL]: 'La Louvière', [LANGUAGES.FR]: 'La Louvière' }, population: 81_556, emission: 122_807_134 },
      { name: { [LANGUAGES.NL]: 'Doornik', [LANGUAGES.FR]: 'Tournai' }, population: 68_968, emission: 103_852_107 },
      { name: { [LANGUAGES.NL]: 'Binche', [LANGUAGES.FR]: 'Binche' }, population: 33_832, emission: 50_944_271 },
      { name: { [LANGUAGES.NL]: 'Courcelles', [LANGUAGES.FR]: 'Courcelles' }, population: 31_637, emission: 47_639_037 }
    ]
  },
  {
    province: 'Namur',
    region: REGIONS.wallonia,
    cities: [
      { name: { [LANGUAGES.NL]: 'Namen', [LANGUAGES.FR]: 'Namur' }, population: 115_330, emission: 173_664_069 },
      { name: { [LANGUAGES.NL]: 'Sambreville', [LANGUAGES.FR]: 'Sambreville' }, population: 28_562, emission: 43_008_698 },
      { name: { [LANGUAGES.NL]: 'Andenne', [LANGUAGES.FR]: 'Andenne' }, population: 28_226, emission: 42_502_749 },
      { name: { [LANGUAGES.NL]: 'Gembloux', [LANGUAGES.FR]: 'Gembloux' }, population: 26_585, emission: 40_031_729 },
      { name: { [LANGUAGES.NL]: 'Jemeppe-sur-Sambre', [LANGUAGES.FR]: 'Jemeppe-sur-Sambre' }, population: 19_250, emission: 28_986_676 },
      { name: { [LANGUAGES.NL]: 'Ciney', [LANGUAGES.FR]: 'Ciney' }, population: 17_140, emission: 25_809_435 }
    ]
  },
  {
    province: 'Liege',
    region: REGIONS.wallonia,
    cities: [
      { name: { [LANGUAGES.NL]: 'Luik', [LANGUAGES.FR]: 'Liège' }, population: 198_044, emission: 298_214_921 },
      { name: { [LANGUAGES.NL]: 'Seraing', [LANGUAGES.FR]: 'Seraing' }, population: 64_744, emission: 97_491_602 },
      { name: { [LANGUAGES.NL]: 'Verviers', [LANGUAGES.FR]: 'Verviers' }, population: 56_128, emission: 84_517_618 },
      { name: { [LANGUAGES.NL]: 'Herstal', [LANGUAGES.FR]: 'Herstal' }, population: 40_849, emission: 61_510_479 },
      { name: { [LANGUAGES.NL]: 'Ans', [LANGUAGES.FR]: 'Ans' }, population: 29_244, emission: 44_035_654 },
      { name: { [LANGUAGES.NL]: 'Flémalle', [LANGUAGES.FR]: 'Flémalle' }, population: 27_158, emission: 40_894_553 }
    ]
  },
  {
    province: 'Luxembourg',
    region: REGIONS.wallonia,
    cities: [
      { name: { [LANGUAGES.NL]: 'Aarlen', [LANGUAGES.FR]: 'Arlon' }, population: 31_391, emission: 47_268_610 },
      { name: { [LANGUAGES.NL]: 'Bastogne', [LANGUAGES.FR]: 'Bastogne' }, population: 21_007, emission: 31_632_369 },
      { name: { [LANGUAGES.NL]: 'Marche-en-Famenne', [LANGUAGES.FR]: 'Marche-en-Famenne' }, population: 18_006, emission: 27_113_459 },
      { name: { [LANGUAGES.NL]: 'Aubange', [LANGUAGES.FR]: 'Aubange' }, population: 17_804, emission: 26_809_287 },
      { name: { [LANGUAGES.NL]: 'Libramont-Chevigny', [LANGUAGES.FR]: 'Libramont-Chevigny' }, population: 12_065, emission: 18_167_493 },
      { name: { [LANGUAGES.NL]: 'Durbuy', [LANGUAGES.FR]: 'Durbuy' }, population: 11_363, emission: 17_110_421 }
    ]
  }
]
